import { BigNumber } from 'bignumber.js';

const bigNumberCache = new Map();
const getBigNumber = (value: number) => {
  const key = value.toString();
  if (!bigNumberCache.has(key)) {
    if (bigNumberCache.size > 200) {
      const firstKey = bigNumberCache.keys().next().value;
      bigNumberCache.delete(firstKey);
    }
    bigNumberCache.set(key, new BigNumber(value));
  }
  return bigNumberCache.get(key);
};

const divisionCache = new Map<string, BigNumber>();

const division = (a: number, b: number): BigNumber => {
  const key = `${a}:${b}`;

  if (!divisionCache.has(key)) {
    if (divisionCache.size > 100) {
      const firstKey = divisionCache.keys().next().value;
      divisionCache.delete(firstKey as string);
    }

    const aBig = getBigNumber(a);
    const bBig = getBigNumber(b);

    divisionCache.set(key, aBig.div(bBig));
  }

  return divisionCache.get(key)!; // Non-null Assertion Operator as there will always be value
};

export { division };
